import React, { useId } from "react";
import classNames from "classnames";
import { clickFromKeyboard } from "@/util/keyboardUtil";
import ChevronArrowIcon from "@/component/icon/ChevronArrowIcon";


interface WebchatDisclosureProps {
    title: string;
    isOpen: boolean;
    onToggle: () => void;
    headItem?: React.ReactNode;
    children: React.ReactNode;
}

const WebchatDisclosure: React.FC<WebchatDisclosureProps> = (props) => {
    const { title, isOpen, onToggle, headItem, children } = props;
    const panelId = useId();

    return (
        <div data-testid="webchat-disclosure"
             className="webchat-setting-card flex flex-col"
        >
            <div tabIndex={0}
                 role="button"
                 aria-expanded={isOpen}
                 aria-label={title}
                 aria-controls={panelId}
                 className={classNames("disclosure-button cursor-pointer", isOpen && "open")}
                 onClick={onToggle}
                 onKeyDown={clickFromKeyboard}
            >
                <div className="text-[14px] font-[600] text-black-500">
                    {title}
                </div>
                {headItem && (
                    <div className="flex items-center ml-auto mr-4"
                         onClick={e => e.stopPropagation()}
                         onKeyDown={e => e.stopPropagation()}
                    >
                        {headItem}
                    </div>
                )}
                <ChevronArrowIcon direction={isOpen ? "up" : "down"}
                                  className="size-4.5 transition-transform duration-200"
                />
            </div>
            <div role="region"
                 id={panelId}
                 aria-hidden={!isOpen}
                 className="transition-disclosure webchat-setting-card-body"
            >
                {children}
            </div>
        </div>
    );
};


export default WebchatDisclosure;
